import { useNavigate } from "react-router-dom";

const useCustomMove = () => {
    const navigate = useNavigate();

    const moveToStart = () => {
        navigate({pathname: `/vendor/start`});
    };
    const moveToBack = () => {
        window.history.back();
    };
    const moveToHome = () => {
        navigate({pathname: `/vendor/main`});
    };
    const moveToStats = () => {
        navigate({pathname: `/vendor/main/stats`});
    };
    const moveToCalc = () => {
        navigate({pathname: `/vendor/main/calc`});
    };
    const moveToSale = () => {
        navigate({pathname: `/vendor/main/sale`});
    };
    const moveToDevice = () => {
        navigate({pathname: `/vendor/main/device`});
    };
    const moveToError = () => {
        navigate({pathname: `/vendor/main/error`});
    };
    const moveToComplete = () => {
        navigate({pathname: `/vendor/main/complete`});
    };
    const moveToCctv = () => {
        navigate({pathname: `/vendor/main/cctv`});
    };

    return {
        moveToStart,
        moveToBack,
        moveToHome,
        moveToStats,
        moveToCalc,
        moveToSale,
        moveToDevice,
        moveToError,
        moveToComplete,
        moveToCctv
    };
};

export default useCustomMove;